if (!customElements.get("tabs-section")) {
  class TabsSection extends HTMLElement {
    constructor() {
      super();

      this.querySelector(".chips--scroll");

      const buttons = this.querySelectorAll("button[aria-controls]");
      const contents = this.querySelectorAll(".tabs__content");
      const showAllLink = this.querySelector(".product-carousel__link, .section-title__link");

      buttons.forEach((button) => {
        button.addEventListener("click", () => {
          const controls = button.getAttribute("aria-controls");
          const content = this.querySelector("#" + controls);

          if (!content) {
            return;
          }

          buttons.forEach((button) => button.setAttribute("aria-expanded", "false"));
          button.setAttribute("aria-expanded", "true");

          contents.forEach((content) => {
            content.classList.remove("tabs__content--active");
            content.classList.remove("tabs__content--visible");
          });

          if (showAllLink) {
            const tabLink = button.dataset.tabLink;

            if (tabLink) {
              showAllLink.href = tabLink;
              showAllLink.hidden = false;
            } else {
              showAllLink.removeAttribute("href");
              showAllLink.hidden = true;
            }
          }

          content.classList.add("tabs__content--active");

          setTimeout(() => {
            content.classList.add("tabs__content--visible");
          });
        });
      });
    }
  }

  customElements.define("tabs-section", TabsSection);
}
